/** The global preset catalogue: no tenant, no parameter. */
class FetchWorkflowCatalog {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchWorkflowCatalog;
